import type { Mouvement } from '@mairistem/comptabilite';
import { isNil } from 'lodash';
import PROFIL_ECRITURE from '../../../constants/mouvements/codeProfilEcritures';
import type BaseProfilEcritureMouvement from './Base/BaseProfilEcritureMouvement';
import ProfilEcritureOPOAvanceSurMarcheFonc from './OPO/ProfilEcritureOPOAvanceSurMarcheFonc';
import ProfilEcritureOPOFonctionnement from './OPO/ProfilEcritureOPOFonctionnement';
import ProfilEcritureOPOInvestissement from './OPO/ProfilEcritureOPOInvestissement';
import ProfilEcritureAffectationResultatRecette from './ProfilEcritureAffectationResultatRecette';
import ProfilEcritureAnnulReducMandatExeCourantDepense from './ProfilEcritureAnnulReducMandatExeCourantDepense';
import ProfilEcritureAnnulTitreFonctExeAnterieurDepense from './ProfilEcritureAnnulTitreFonctExeAnterieurDepense';
import ProfilEcritureAnnulTitreInvestExeAnterieurDepense from './ProfilEcritureAnnulTitreInvestExeAnterieurDepense';
import ProfilEcritureCreanceEteinteDepense from './ProfilEcritureCreanceEteinteDepense';
import ProfilEcritureFonctEmiseApresPaiementDepense from './ProfilEcritureFonctEmiseApresPaiementDepense';
import ProfilEcritureInvesAvecInfoInvEmiseApPaiementDepense from './ProfilEcritureInvesAvecInfoInvEmiseApPaiementDepense';
import ProfilEcritureInvesSansInfoInvEmiseApPaiementDepense from './ProfilEcritureInvesSansInfoInvEmiseApPaiementDepense';
import ProfilEcritureLibreDepense from './ProfilEcritureLibreDepense';
import ProfilEcritureLibreRecette from './ProfilEcritureLibreRecette';
import ProfilEcritureLieeEmpruntDepense from './ProfilEcritureLieeEmpruntDepense';
import ProfilEcritureLieeEmpruntRecette from './ProfilEcritureLieeEmpruntRecette';
import ProfilEcritureMarcheDernierAcompteDepense from './ProfilEcritureMarcheDernierAcompteDepense';
import ProfilEcritureMarcheFoncDepense from './ProfilEcritureMarcheFoncDepense';
import ProfilEcritureMarcheInvAvanceForfaitDepense from './ProfilEcritureMarcheInvAvanceForfaitDepense';
import ProfilEcritureMarcheInvAvecInventDepense from './ProfilEcritureMarcheInvAvecInventDepense';
import ProfilEcritureMarcheInvSansInventDepense from './ProfilEcritureMarcheInvSansInventDepense';
import ProfilEcritureMarcheRecette from './ProfilEcritureMarcheRecette';
import ProfilEcritureMarcheRetGarantMandatDistDepense from './ProfilEcritureMarcheRetGarantMandatDistDepense';
import ProfilEcritureOrdFoncDepense from './ProfilEcritureOrdFoncDepense';
import ProfilEcritureOrdFoncRecette from './ProfilEcritureOrdFoncRecette';
import ProfilEcritureOrdInvAvecInventDepense from './ProfilEcritureOrdInvAvecInventDepense';
import ProfilEcritureOrdInvAvecInventRecette from './ProfilEcritureOrdInvAvecInventRecette';
import ProfilEcritureOrdInvSansInventDepense from './ProfilEcritureOrdInvSansInventDepense';
import ProfilEcritureOrdInvSansInventRecette from './ProfilEcritureOrdInvSansInventRecette';
import ProfilEcritureOrdreBudgetaireSectASectInvestissementAvecInfoInvRecette from './ProfilEcritureOrdreBudgetaireSectASectInvestissementAvecInfoInvRecette';
import ProfilEcritureOrdreBudgetaireSectASectInvestissementSansInfoInvRecette from './ProfilEcritureOrdreBudgetaireSectASectInvestissementSansInfoInvRecette';
import ProfilEcritureOrdreBudgetaireSectInvestissementAvecInfoInvRecette from './ProfilEcritureOrdreBudgetaireSectInvestissementAvecInfoInvRecette';
import ProfilEcritureOrdreBudgetaireSectInvestissementOpePatrimonialeAvecInfoInv from './ProfilEcritureOrdreBudgetaireSectInvestissementOpePatrimonialeAvecInfoInv';
import ProfilEcritureOrdreBudgetaireSectInvestissementOpePatrimonialeSansInfoInv from './ProfilEcritureOrdreBudgetaireSectInvestissementOpePatrimonialeSansInfoInv';
import ProfilEcritureOrdreBudgetaireSectInvestissementSansInfoInvRecette from './ProfilEcritureOrdreBudgetaireSectInvestissementSansInfoInvRecette';
import ProfilEcritureOrdreBudgetaireSectionASectionFonctionnementAvecInfoInventaire from './ProfilEcritureOrdreBudgetaireSectionASectionFonctionnementAvecInfoInventaire';
import ProfilEcritureOrdreBudgetaireSectionASectionFonctionnementAvecInfoInventaireRecette from './ProfilEcritureOrdreBudgetaireSectionASectionFonctionnementAvecInfoInventaireRecette';
import ProfilEcritureOrdreBudgetaireSectionASectionInvestissementAvecInfoInventaire from './ProfilEcritureOrdreBudgetaireSectionASectionInvestissementAvecInfoInventaire';
import ProfilEcritureOrdreBudgetaireSectionASectionInvestissementSansInfoInventaire from './ProfilEcritureOrdreBudgetaireSectionASectionInvestissementSansInfoInventaire';
import ProfilEcritureRegieDepense from './ProfilEcritureRegieDepense';
import ProfilEcritureRegieRecette from './ProfilEcritureRegieRecette';
import ProfilEcritureRelevantPaieCollectifDepense from './ProfilEcritureRelevantPaieCollectifDepense';
import ProfilEcritureRelevantPaieIndividuelDepense from './ProfilEcritureRelevantPaieIndividuelDepense';
import ProfilEcritureTitreRecapRoleRecette from './ProfilEcritureTitreRecapRoleRecette';
import ProfilEcritureTravauxRegieAvecInfoInventaireDepense from './ProfilEcritureTravauxRegieAvecInfoInventaireDepense';
import ProfilEcritureTravauxRegieSansInfoInventaireDepense from './ProfilEcritureTravauxRegieSansInfoInventaireDepense';
import ProfilEcritureAdmissionsNonValeurDepense from './Rattachement/ProfilEcritureAdmissionsNonValeurDepense';
import ProfilEcritureAnnulantMandatFonctionnementExerciceAnterieur from './Rattachement/ProfilEcritureAnnulantMandatExerciceAnterieur';
import ProfilEcritureAnnulantMandatInvestissementExerciceAnterieur from './Rattachement/ProfilEcritureAnnulantMandatInvestissementExerciceAnterieur';
import ProfilEcritureAnnulationReductionTitreExerciceCourantRecette from './Rattachement/ProfilEcritureAnnulationReductionTitreExerciceCourantRecette';
import ProfilEcritureEmpruntEmisApresPaiementDepense from './Rattachement/ProfilEcritureEmpruntEmisApresPaiementDepense';
import ProfilEcritureFonctionnementEmisApresEncaissementRecette from './Rattachement/ProfilEcritureFonctionnementEmisApresEncaissementRecette';
import ProfilEcritureInvesAvecInfoInvEmiseApPaiementRecette from './Rattachement/ProfilEcritureInvesAvecInfoInvEmiseApPaiementRecette';
import ProfilEcritureInvesSansInfoInvEmiseApPaiementRecette from './Rattachement/ProfilEcritureInvesSansInfoInvEmiseApPaiementRecette';
import ProfilEcritureLieeEmpruntEmiseApEncaissementRecette from './Rattachement/ProfilEcritureLieeEmpruntEmiseApEncaissementRecette';
import ProfilEcritureRegieEmiseApresEncaissement from './Rattachement/ProfilEcritureRegieEmiseApresEncaissement';
import ProfilEcritureRegieEmiseApresPaiement from './Rattachement/ProfilEcritureRegieEmiseApresPaiement';
import ProfilEcritureTravauxRegieRecette from './Rattachement/ProfilEcritureTravauxRegieRecette';

// biome-ignore lint/complexity/noStaticOnlyClass: Je ne sais pas pourquoi c'est en static
class ProfilEcritureFactory {
	static newInstance(
		codeProfil: string,
		piece: Mouvement,
	): BaseProfilEcritureMouvement {
		let profil = null;

		switch (codeProfil) {
			case PROFIL_ECRITURE.DEPENSE.SAI_LIB:
				profil = new ProfilEcritureLibreDepense();
				break;
			case PROFIL_ECRITURE.DEPENSE.ORD_FONC:
				profil = new ProfilEcritureOrdFoncDepense();
				break;
			case PROFIL_ECRITURE.DEPENSE.ORD_INV_AVEC_INVENT:
				profil = new ProfilEcritureOrdInvAvecInventDepense();
				break;
			case PROFIL_ECRITURE.DEPENSE.ORD_INV_SANS_INVENT:
				profil = new ProfilEcritureOrdInvSansInventDepense();
				break;
			case PROFIL_ECRITURE.DEPENSE.MARCHE_FONC:
				profil = new ProfilEcritureMarcheFoncDepense();
				break;
			case PROFIL_ECRITURE.DEPENSE.MARCHE_INV_AVEC_INVENT:
				profil = new ProfilEcritureMarcheInvAvecInventDepense();
				break;
			case PROFIL_ECRITURE.DEPENSE.MARCHE_INV_SANS_INVENT:
				profil = new ProfilEcritureMarcheInvSansInventDepense();
				break;
			case PROFIL_ECRITURE.DEPENSE.MARCHE_INV_AVANCE_FORFAIT:
				profil = new ProfilEcritureMarcheInvAvanceForfaitDepense();
				break;
			case PROFIL_ECRITURE.DEPENSE.MARCHE_RET_GARANT_MANDAT_DIST:
				profil = new ProfilEcritureMarcheRetGarantMandatDistDepense();
				break;
			case PROFIL_ECRITURE.DEPENSE.MARCHE_DERNIER_ACOMPTE:
				profil = new ProfilEcritureMarcheDernierAcompteDepense();
				break;
			case PROFIL_ECRITURE.DEPENSE.REGIE:
				profil = new ProfilEcritureRegieDepense();
				break;
			case PROFIL_ECRITURE.DEPENSE.ANNUL_REDUC_MANDAT_EXE_COURANT:
				profil = new ProfilEcritureAnnulReducMandatExeCourantDepense(
					piece?.exercice?.anneeExercice,
				);
				break;
			case PROFIL_ECRITURE.DEPENSE.LIEE_EMPRUNT:
				profil = new ProfilEcritureLieeEmpruntDepense();
				break;
			case PROFIL_ECRITURE.DEPENSE.RELEVANT_PAIE_INDIVIDUEL:
				profil = new ProfilEcritureRelevantPaieIndividuelDepense();
				break;
			case PROFIL_ECRITURE.DEPENSE.RELEVANT_PAIE_COLLECTIF:
				profil = new ProfilEcritureRelevantPaieCollectifDepense();
				break;
			case PROFIL_ECRITURE.DEPENSE.FONCT_EMISE_APRES_PAIEMENT:
				profil = new ProfilEcritureFonctEmiseApresPaiementDepense(
					piece?.exercice?.anneeExercice,
				);
				break;
			case PROFIL_ECRITURE.DEPENSE.INVES_AVEC_INFO_INV_EMISE_AP_PAIEMENT:
				profil = new ProfilEcritureInvesAvecInfoInvEmiseApPaiementDepense(
					piece?.exercice?.anneeExercice,
				);
				break;
			case PROFIL_ECRITURE.DEPENSE.INVES_SANS_INFO_INV_EMISE_AP_PAIEMENT:
				profil = new ProfilEcritureInvesSansInfoInvEmiseApPaiementDepense(
					piece?.exercice?.anneeExercice,
				);
				break;
			case PROFIL_ECRITURE.DEPENSE.REGIE_EMISE_AP_PAIEMENT:
				profil = new ProfilEcritureRegieEmiseApresPaiement(
					piece?.exercice?.anneeExercice,
				);
				break;
			case PROFIL_ECRITURE.DEPENSE.LIEE_EMPRUNT_EMISE_AP_PAIEMENT:
				profil = new ProfilEcritureEmpruntEmisApresPaiementDepense(
					piece?.exercice?.anneeExercice,
				);
				break;
			case PROFIL_ECRITURE.DEPENSE.TRAV_REGIE_AVEC_INFO_INV:
				profil = new ProfilEcritureTravauxRegieAvecInfoInventaireDepense();
				break;
			case PROFIL_ECRITURE.DEPENSE.TRAV_REGIE_SANS_INFO_INV:
				profil = new ProfilEcritureTravauxRegieSansInfoInventaireDepense();
				break;
			case PROFIL_ECRITURE.DEPENSE.ORDRE_BUDG_SECT_A_SECT_INVES_AVEC_INFO_INV:
				profil =
					new ProfilEcritureOrdreBudgetaireSectionASectionInvestissementAvecInfoInventaire();
				break;
			case PROFIL_ECRITURE.DEPENSE.ORDRE_BUDG_SECT_A_SECT_INVES_SANS_INFO_INV:
				profil =
					new ProfilEcritureOrdreBudgetaireSectionASectionInvestissementSansInfoInventaire();
				break;
			case PROFIL_ECRITURE.DEPENSE.ORDRE_BUDG_SECT_A_SECT_FONCT_AVEC_INFO_INV:
				profil =
					new ProfilEcritureOrdreBudgetaireSectionASectionFonctionnementAvecInfoInventaire();
				break;
			case PROFIL_ECRITURE.DEPENSE
				.ORDRE_BUDG_INTERIEUR_SECT_INVES_AVEC_INFO_INV:
				profil =
					new ProfilEcritureOrdreBudgetaireSectInvestissementOpePatrimonialeAvecInfoInv();
				break;
			case PROFIL_ECRITURE.DEPENSE
				.ORDRE_BUDG_INTERIEUR_SECT_INVES_SANS_INFO_INV:
				profil =
					new ProfilEcritureOrdreBudgetaireSectInvestissementOpePatrimonialeSansInfoInv();
				break;
			case PROFIL_ECRITURE.DEPENSE.ANNUL_TITRE_FONCT_EXE_ANTERIEUR:
				profil = new ProfilEcritureAnnulTitreFonctExeAnterieurDepense(
					piece?.exercice?.anneeExercice,
				);
				break;
			case PROFIL_ECRITURE.DEPENSE.ANNUL_TITRE_INVES_EXE_ANTERIEUR:
				profil = new ProfilEcritureAnnulTitreInvestExeAnterieurDepense(
					piece?.exercice?.anneeExercice,
				);
				break;
			case PROFIL_ECRITURE.DEPENSE.CREANCE_ETEINTE:
				profil = new ProfilEcritureCreanceEteinteDepense();
				break;
			case PROFIL_ECRITURE.DEPENSE.ADMISSIONS_NON_VALEUR:
				profil = new ProfilEcritureAdmissionsNonValeurDepense(
					piece?.exercice?.anneeExercice,
				);
				break;
			case PROFIL_ECRITURE.DEPENSE.OPO_FONC:
				profil = new ProfilEcritureOPOFonctionnement();
				break;
			case PROFIL_ECRITURE.DEPENSE.OPO_INV:
				profil = new ProfilEcritureOPOInvestissement();
				break;
			case PROFIL_ECRITURE.DEPENSE.OPO_AVANCE_MARCHE_FONC:
				profil = new ProfilEcritureOPOAvanceSurMarcheFonc();
				break;
			case PROFIL_ECRITURE.RECETTE.SAI_LIB:
				profil = new ProfilEcritureLibreRecette();
				break;
			case PROFIL_ECRITURE.RECETTE.ORD_FONC:
				profil = new ProfilEcritureOrdFoncRecette();
				break;
			case PROFIL_ECRITURE.RECETTE.TITRE_RECAP_ROLE:
				profil = new ProfilEcritureTitreRecapRoleRecette();
				break;
			case PROFIL_ECRITURE.RECETTE.ORD_INV_AVEC_INVENT:
				profil = new ProfilEcritureOrdInvAvecInventRecette();
				break;
			case PROFIL_ECRITURE.RECETTE.ORD_INV_SANS_INVENT:
				profil = new ProfilEcritureOrdInvSansInventRecette();
				break;
			case PROFIL_ECRITURE.RECETTE.MARCHE:
				profil = new ProfilEcritureMarcheRecette();
				break;
			case PROFIL_ECRITURE.RECETTE.REGIE:
				profil = new ProfilEcritureRegieRecette();
				break;
			case PROFIL_ECRITURE.RECETTE.LIEE_EMPRUNT:
				profil = new ProfilEcritureLieeEmpruntRecette();
				break;
			case PROFIL_ECRITURE.RECETTE.ANNUL_REDUC_TITRE_EXE_COURANT:
				profil =
					new ProfilEcritureAnnulationReductionTitreExerciceCourantRecette(
						piece?.exercice?.anneeExercice,
					);
				break;
			case PROFIL_ECRITURE.RECETTE.ANNULANT_MANDAT_FONCT_EXERCICE_ANTERIEUR:
				profil =
					new ProfilEcritureAnnulantMandatFonctionnementExerciceAnterieur(
						piece?.exercice?.anneeExercice,
					);
				break;
			case PROFIL_ECRITURE.RECETTE.ANNULANT_MANDAT_INVEST_EXE_ANTERIEUR:
				profil =
					new ProfilEcritureAnnulantMandatInvestissementExerciceAnterieur(
						piece?.exercice?.anneeExercice,
					);
				break;
			case PROFIL_ECRITURE.RECETTE.FONC_EMIS_APRES_ENCAISSEMENT:
				profil = new ProfilEcritureFonctionnementEmisApresEncaissementRecette(
					piece?.exercice?.anneeExercice,
				);
				break;
			case PROFIL_ECRITURE.RECETTE.INVEST_AVEC_INFO_INV_EMISE_APRES_PAIEMENT:
				profil = new ProfilEcritureInvesAvecInfoInvEmiseApPaiementRecette(
					piece?.exercice?.anneeExercice,
				);
				break;
			case PROFIL_ECRITURE.RECETTE.INVEST_SANS_INFO_INV_EMISE_APRES_PAIEMENT:
				profil = new ProfilEcritureInvesSansInfoInvEmiseApPaiementRecette(
					piece?.exercice?.anneeExercice,
				);
				break;
			case PROFIL_ECRITURE.RECETTE.REGIE_EMISE_APRES_ENCAISSEMENT:
				profil = new ProfilEcritureRegieEmiseApresEncaissement(
					piece?.exercice?.anneeExercice,
				);
				break;
			case PROFIL_ECRITURE.RECETTE.LIEE_EMPRUNT_EMISE_APRES_ENCAISSEMENT:
				profil = new ProfilEcritureLieeEmpruntEmiseApEncaissementRecette(
					piece?.exercice?.anneeExercice,
				);
				break;
			case PROFIL_ECRITURE.RECETTE.AFFECTATION_RESULTAT:
				profil = new ProfilEcritureAffectationResultatRecette();
				break;
			case PROFIL_ECRITURE.RECETTE.TRAVAUX_REGIE:
				profil = new ProfilEcritureTravauxRegieRecette(
					piece?.exercice?.anneeExercice,
				);
				break;
			case PROFIL_ECRITURE.RECETTE.ORDRE_BUDG_SECT_A_SECT_INVES_AVEC_INFO_INV:
				profil =
					new ProfilEcritureOrdreBudgetaireSectASectInvestissementAvecInfoInvRecette();
				break;
			case PROFIL_ECRITURE.RECETTE.ORDRE_BUDG_SECT_A_SECT_INVES_SANS_INFO_INV:
				profil =
					new ProfilEcritureOrdreBudgetaireSectASectInvestissementSansInfoInvRecette();
				break;
			case PROFIL_ECRITURE.RECETTE.ORDRE_BUDG_SECT_A_SECT_FONCT_AVEC_INFO_INV:
				profil =
					new ProfilEcritureOrdreBudgetaireSectionASectionFonctionnementAvecInfoInventaireRecette();
				break;
			case PROFIL_ECRITURE.RECETTE
				.ORDRE_BUDG_INTERIEUR_SECT_INVES_AVEC_INFO_INV:
				profil =
					new ProfilEcritureOrdreBudgetaireSectInvestissementAvecInfoInvRecette();
				break;
			case PROFIL_ECRITURE.RECETTE
				.ORDRE_BUDG_INTERIEUR_SECT_INVES_SANS_INFO_INV:
				profil =
					new ProfilEcritureOrdreBudgetaireSectInvestissementSansInfoInvRecette();
				break;
			default:
				break;
		}

		if (!isNil(profil)) {
			profil.entite = piece?.exercice?.entite ?? {};
		}

		return profil;
	}
}

export default ProfilEcritureFactory;
